import React from 'react';
import { PriceLabel } from 'components';
const columns = () => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'تاریخ',
    field: 'date',
    align: 'center',
    filtering: false,
  },

  {
    title: 'مجموع مبلغ تراکنش واریز',
    field: 'sumDiscount',
    align: 'center',
    filtering: false,
    render: (rowData) => (
      <PriceLabel amount={rowData.sumDiscount} />
    ),
  },
  {
    //title: 'مانده  و اعتباری قابل مصرف',
    title: 'مجموع مبلغ تراکنش برداشت',
    field: 'sumWithral',
    align: 'center',
    filtering: false,
    render: (rowData) => (
      <PriceLabel amount={rowData.sumWithral} />
    ),
  },
];

export { columns };
